var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.645200 0 0 0 0 0.647797 0 0 0 0 0.648438 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.804099015,0.140338036 L0.140759471,0.803256144 C-0.0484650874,0.992480703 -0.0455150386,1.29212137 0.140759471,1.47839588 L12.8495697,14.1888918 C13.0371085,14.3760092 13.3384349,14.3751664 13.5247094,14.1884704 L14.1876275,13.5255523 C14.3772735,13.3363277 14.3743235,13.0366871 14.188049,12.8504126 L1.47923875,0.1399166 C1.38568006,0.0463579097 1.26388519,0 1.14209032,0 C1.01987401,0 0.89723627,0.0467793452 0.804099015,0.140338036 L0.804099015,0.140338036 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B9\\u30BF\\u30C3\\u30D5\\u30FB\\u6559\\u5E2B\\u4E00\\u89A7",
    transform: "translate(-895.000000, -203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-Cross/close",
    transform: "translate(240.000000, 185.500000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(655.000000, 17.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 1.02348632,
    y1: 1.02348632,
    x2: 13.3053221,
    y2: 13.3053221,
    id: "Stroke-23",
    stroke: "#34495E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3053221,
    y1: 1.02348632,
    x2: 1.02348632,
    y2: 13.3053221,
    id: "Stroke-25",
    stroke: "#34495E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e6e12fafa344eb87a9b500415aec62ad.svg";
export { ForwardRef as ReactComponent };